import { TSubCategoryAction, SubCategoryActionTypes } from './subCategoryActions';
import { ISubCategoryState } from './subCategoryContext';

export const subCategoryReducer = (state: ISubCategoryState, action: TSubCategoryAction): ISubCategoryState => {
	switch (action.type) {
		case SubCategoryActionTypes.SET_SUBCATEGORIES:
			return {
				...state,
				subCategories: action.payload.subCategories,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case SubCategoryActionTypes.CHANGE_SEARCH_STRING:
			return {
				...state,
				searchString: action.payload.searchString,
				currentPage: 1,
			};
		case SubCategoryActionTypes.SET_ID_CUSTOMER:
			return {
				...state,
				IDSelectedCustomer: action.payload.IDSelectedCustomer,
				IDSelectedRestaurant: null,
				IDSelectedCategory: null,
				subCategoryIsHidden: false,
				currentPage: 1,
			};
		case SubCategoryActionTypes.SET_ID_RESTAURANT:
			return {
				...state,
				IDSelectedRestaurant: action.payload.IDSelectedRestaurant,
				IDSelectedCategory: null,
				subCategoryIsHidden: false,
				currentPage: 1,
			};
		case SubCategoryActionTypes.SET_ID_CATEGORY:
			return {
				...state,
				IDSelectedCategory: action.payload.IDSelectedCategory,
				currentPage: 1,
			};
		case SubCategoryActionTypes.RESET_SELECTED_CONTROLS:
			return {
				...state,
				searchString: '',
				IDSelectedCustomer: null,
				IDSelectedRestaurant: null,
				IDSelectedCategory: null,
				subCategoryIsHidden: false,
				currentPage: 1,
			};
		case SubCategoryActionTypes.SET_SORT_BY:
			return {
				...state,
				sortBy: action.payload.sortBy,
				currentPage: 1,
			};
		case SubCategoryActionTypes.SET_COUNT_OF_ITEMS:
			return {
				...state,
				countOfItems: action.payload.countOfItems,
				currentPage: 1,
			};
		case SubCategoryActionTypes.TOGGLE_SUB_CATEGORY_IS_HIDDEN:
			return {
				...state,
				subCategoryIsHidden: !state.subCategoryIsHidden,
				currentPage: 1,
			};
		case SubCategoryActionTypes.CHANGE_CURRENT_PAGE:
			return {
				...state,
				currentPage: action.payload.currentPage,
			};
		case SubCategoryActionTypes.SET_ID_FOR_DELETION:
			return {
				...state,
				IDForDeletion: action.payload.IDForDeletion,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case SubCategoryActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case SubCategoryActionTypes.SET_FILTERS_FROM_QUERY_STRING:
			return {
				...state,
				...action.payload.filters,
			};
		default:
			return state;
	}
};
